export const isMobileDevice = () => {
	const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent
	return Boolean(userAgent.match(/Android|BlackBerry|webOS|iPhone|iPod|Windows Phone/i))
}

export const isTabletDevice = () => {
	const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent
	return Boolean(
		userAgent.toLowerCase().match(
			// eslint-disable-next-line max-len
			/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/
		)
	)
}
